import { Reveal, RiseHeading } from "@/components/motion";

// Traditional-yet-modern inner page header
const PageHeader = ({ overline, title, description, testid = "page-header", image }) => (
  <section data-testid={testid} className="border-b border-black/10 bg-cream/50">
    <div className="mx-auto grid max-w-[1400px] items-end gap-10 px-5 pb-14 pt-32 md:grid-cols-12 md:gap-14 md:px-8 md:pb-20 md:pt-40">
      <div className={image ? "md:col-span-7" : "md:col-span-12"}>
        <Reveal>
          <span className="eyebrow rule">{overline}</span>
        </Reveal>
        <RiseHeading className="mt-6 max-w-4xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
          {title}
        </RiseHeading>
        {description && (
          <Reveal delay={0.15}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
              {description}
            </p>
          </Reveal>
        )}
      </div>
      {image && (
        <div className="md:col-span-5">
          <Reveal delay={0.2}>
            <div className="overflow-hidden rounded-sm border border-black/10">
              <img src={image} alt="" className="h-64 w-full object-cover md:h-80" />
            </div>
          </Reveal>
        </div>
      )}
    </div>
  </section>
);

export default PageHeader;
